import i18n from "@/modules/i18n"
import JoinPage from "./components/join-page"
import createComponent from "@/utils/create-component"

export default () => {
  const el = document.getElementById("vue-organisations-join")

  if (!el) {
    // prevent trying to mount the component when in another page
    return
  }

  const { categoryProps } = el.dataset

  createComponent({
    el: el,
    component: JoinPage,
    props: {
      categoryProps: JSON.parse(categoryProps)
    },
    i18n
  })
}
